import { Box } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
// import useBreadCrumbs from '../../../hooks/useBreadCrumb';
import useFinanceHeader from '../../../hooks/useFinanceHeader';
import useToggleSideNav from '../../../hooks/useToggleSideNav';
// import useToast from '../../../hooks/useToast';
import DiscoverAppPanel from './DiscoverAppPanel';
// import { confirmAdmissionColumn1 } from '../ConfirmAdmissionScreen/columns';
import {
  getApprovalsDiscoveryAsync,
  getApprovalsDiscoveryPanelAsync,
} from './AdmissionFeeStore/AdmissionFeeSlice';
import { getApprovalListAsync } from '../ApprovalStore/approvalSlice';
import { DISCOVERY_REVIEW_TABLE_COLUMNS } from './column';

// const sortByOptions1 = [
//   { label: 'KYC Approval', value: 'KYC Approval' },
//   { label: 'Teenybeans', value: 'Teenybeans' },
//   { label: 'Atheneum', value: 'Atheneum' },
// ];

const DiscoveryAppApproval = () => {
  const { setHeader, setSubHeader } = useFinanceHeader();
  const { showSideNav } = useToggleSideNav();
  const dispatch = useDispatch();
  const [sortByPanel, setSortByPanel] = useState('week');
  const [page, setPage] = useState(1);
  // const { ErrorToast } = useToast();
  const [status, setStatus] = useState('pending');

  const PER_PAGE_FOR_REVIEW = 8;
  const STATUS_OPTION = [
    { label: 'Pending', value: 'pending' },
    { label: 'Approve', value: 'approve' },
    { label: 'Disapprove', value: 'disapprove' },
  ];

  const { mgmentPanel, approvalList, approvalCount } = useSelector(
    ({ discountStoreReducer, approvalReducer }) => {
      return {
        mgmentPanel: discountStoreReducer.mgmentPanel,
        approvalList: approvalReducer.commonApprovalList,
        approvalCount: approvalReducer.commonApprovalCount,
      };
    }
  );
  useEffect(() => {
    dispatch(getApprovalsDiscoveryPanelAsync({ sortby: 'week' }));
    dispatch(getApprovalsDiscoveryAsync({ page: 1, limit: 8 }));
    dispatch(
      getApprovalListAsync({
        params: {
          entityType: 'review',
          approvalType: 'review-status',
          limit: PER_PAGE_FOR_REVIEW,
          page: 1,
          statuses: ['pending'],
        },
        type: 'common',
      })
    );
  }, []);

  const handleSortInfo = (e) => {
    setSortByPanel(e.target.value);
    // API call
    dispatch(getApprovalsDiscoveryPanelAsync({ sortby: e.target.value }));
  };

  // const { setBreadCrumbs } = useBreadCrumbs();
  useEffect(() => {
    setHeader('Approval Management');
    setSubHeader('Managing Approval');
    // setBreadCrumbs(breadCrumbLinks);
    showSideNav();
  }, []);

  const handlePageChange = (val) => {
    console.log('outside');

    if (val !== page) {
      console.log('inside');
      setPage(val);
      // dispatch(
      //   getApprovalsDiscoveryAsync({
      //     page: val,
      //     limit: 8,
      //     // sort,
      //   })
      // )
      //   .unwrap()
      //   .then((res) => {
      //     if (res && res.status > 299) {
      //       ErrorToast(res.message);
      //     }
      //   })
      //   .catch((err) => {
      //     ErrorToast(err.message);
      //   });
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'review',
            approvalType: 'review-status',
            limit: PER_PAGE_FOR_REVIEW,
            page: val,
            statuses: ['pending'],
          },
          type: 'common',
        })
        // .unwrap()
        // .then((res) => {
        //   if (res && res.status > 299) {
        //     ErrorToast(res.message);
        //   }
        // })
        // .catch((err) => {
        //   ErrorToast(err.message);
        // })
      );
    }
  };

  const handleStatus = (e) => {
    setStatus(e.target.value);
    dispatch(
      getApprovalListAsync({
        params: {
          entityType: 'review',
          approvalType: 'review-status',
          limit: PER_PAGE_FOR_REVIEW,
          page: 1,
          statuses: [e.target.value],
        },
        type: 'common',
      })
    );
  };

  return (
    <Box>
      <Box mb={2} fontSize={22} fontWeight={'fontWeightMedium'}>
        Approval Panel
      </Box>
      <Box mb={2}>
        <BuzzSelect
          labelKey="label"
          valueKey="value"
          width={200}
          size={'small'}
          value={sortByPanel}
          onChange={handleSortInfo}
          options={[
            { label: 'Last Week', value: 'week' },
            { label: 'Last Month', value: 'month' },
            { label: 'Last Year', value: 'year' },
          ]}
        />
      </Box>
      <Box mb={8}>
        <DiscoverAppPanel
          requestedReview={mgmentPanel ? mgmentPanel.requestedReviews : 0}
          approvedReview={mgmentPanel ? mgmentPanel.approvedReviews : 0}
          rejectedReviews={mgmentPanel ? mgmentPanel.rejectedReview : 0}
          // enquiries={mgmentPanel ? mgmentPanel.enquires : 0}
        />
      </Box>
      <Box mb={2} fontSize={22} fontWeight={'fontWeightMedium'}>
        Reviews
      </Box>
      <Box mb={2} display="flex">
        <Box width={250}>
          <BuzzSelect
            width={250}
            name="status"
            size={'small'}
            placeholder={'Select status'}
            value={status}
            onChange={handleStatus}
            label="Select status"
            valueKey="value"
            labelKey="label"
            options={STATUS_OPTION}
          />
        </Box>
      </Box>
      <Box>
        <Box
          display="flex"
          flex={1}
          mt={2}
          // className={styles.boxContainer}
        ></Box>
        {/* <BuzzTable columns={confirmAdmissionColumn1} data={appDiscover} /> */}
        <BuzzTable
          columns={DISCOVERY_REVIEW_TABLE_COLUMNS}
          data={approvalList}
        />
        {approvalList && approvalList.length === 0 && (
          <Box width={'100%'} display="flex" justifyContent={'center'} pt={2}>
            No data found
          </Box>
        )}
        <Box display="flex" justifyContent="center">
          <BuzzPagination
            onClick={handlePageChange}
            total={approvalCount}
            pageNo={page}
            defaultPage={1}
            perPage={8}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DiscoveryAppApproval;
